export default {
  routes: [
    {
      name: 'summary_docs',
      path: '/directory/summary_docs',
      component: () => import('./views/TheSummaryDocsTypes.vue'),

    },

    {
      name: 'summary_doc',
      path: '/directory/summary_docs/:uuid',
      component: () => import('./views/TheSummaryDocsType.vue'),
    },
  ]
}
